let suppressDuelInteractionsUntil = 0;

export function suppressDuelInteractions(durationMs = 350): void {
  suppressDuelInteractionsUntil = Date.now() + durationMs;
}

export function isDuelInteractionSuppressed(): boolean {
  return Date.now() < suppressDuelInteractionsUntil;
}
